import type * as React from 'react';

import { Button as MuiButton } from '@material-ui/core';
import type { ButtonProps as MuiButtonProps } from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';

import { Loading } from '../..';
import { buttons, colors, fonts } from '../../styles';

export interface ButtonProps extends MuiButtonProps {
  condensed?: boolean;
  loading?: boolean;
  customLoadingColor?: string;
}

const StyledButton = withStyles({
  root: {
    whiteSpace: 'nowrap',
    minWidth: buttons.minWidth,
    padding: buttons.padding,
    boxSizing: 'border-box',
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: fonts.size.small,
    fontWeight: fonts.weight.bold,
    display: 'flex',
    alignItems: 'center',
    color: '#FFF',
    minHeight: 'auto',
    height: buttons.height,
    '&:disabled': { color: '#FFF' },
    '& span': {
      color: '#FFF',
      cursor: 'pointer',
      fontWeight: fonts.weight.bold,
      fontSize: fonts.size.small,
    },
  },
  sizeSmall: {
    height: buttons.condensed.height,
  },
  label: {
    letterSpacing: 'normal',
  },
})(MuiButton);

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Button: React.FC<ButtonProps> = (props) => {
  const { condensed, loading, customLoadingColor, children, ...otherProps } = props;
  const content = loading ? <Loading fill={customLoadingColor || colors.white} /> : children;
  return (
    <StyledButton size={props.condensed ? 'small' : undefined} {...otherProps} disabled={props.disabled || props.loading}>
      {content}
    </StyledButton>
  );
};
